import React, { useState, useEffect } from 'react'
import { apiFetch } from './api';
import { useNavigate } from 'react-router-dom'
import RouteMapping from './RouteMapping'
import VendorMapping from './VendorMapping'
import ReportsPage from './ReportsPage'

function useCurrentUser() {
  const [user, setUser] = useState(null)
  useEffect(() => {
    apiFetch('/api/me', { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(setUser)
  }, [])
  return user
}
export default function DoctorKanika(){
  const nav = useNavigate()
  const [tab, setTab] = useState('reports')
  // Supervisor state
  const [supervisors, setSupervisors] = useState([])
  const [newName, setNewName] = useState('')
  const [editId, setEditId] = useState(null)
  const [editName, setEditName] = useState('')
  const [loading, setLoading] = useState(false)
  const company = 'doctor-kanika'
  const user = useCurrentUser()
  const isSupervisor = user && user.roles && user.roles.includes('ROLE_SUPERVISOR')

  // Fetch supervisors for this company from backend
  useEffect(() => {
    apiFetch(`/api/supervisors?company=${company}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : [])
      .then(setSupervisors)
  }, [])

  // Add supervisor
  const handleAdd = async e => {
    e.preventDefault()
    if (!newName.trim()) return
    setLoading(true)
    const res = await apiFetch('/api/supervisors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ name: newName, company })
    })
    if (res.ok) {
      const sup = await res.json()
      setSupervisors(sups => [...sups, sup])
      setNewName('')
      localStorage.setItem('kanika-mapping-tab', '1');
      window.location.reload();
    }
    setLoading(false)
  }
  // Start edit
  const startEdit = sup => {
    setEditId(sup.id)
    setEditName(sup.name)
  }
  // Save edit
  const handleEdit = async e => {
    e.preventDefault()
    setLoading(true)
    const res = await apiFetch(`/api/supervisors/${editId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ name: editName, company })
    })
    if (res.ok) {
      setSupervisors(sups => sups.map(s => s.id === editId ? { ...s, name: editName } : s))
      setEditId(null)
      setEditName('')
      localStorage.setItem('kanika-mapping-tab', '1');
      window.location.reload();
    }
    setLoading(false)
  }
  // Delete supervisor
  const handleDelete = async id => {
    setLoading(true)
    const res = await apiFetch(`/api/supervisors/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    })
    if (res.ok) {
      setSupervisors(sups => sups.filter(s => s.id !== id))
      if (editId === id) { setEditId(null); setEditName('') }
      localStorage.setItem('kanika-mapping-tab', '1');
      window.location.reload();
    }
    setLoading(false)
  }

  // reports handled by shared ReportsPage component
  useEffect(() => {
    if (localStorage.getItem('kanika-mapping-tab')) {
      setTab('mapping');
      localStorage.removeItem('kanika-mapping-tab');
    }
  }, []);

  return (
    <div style={{padding:20,display:'flex',gap:32}}>
      <div style={{minWidth:180}}>
        <div style={{fontWeight:700,fontSize:18,marginBottom:18}}>Doctor Kanika</div>
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          <button className={tab==='reports' ? 'btn primary' : 'btn secondary'} onClick={()=>setTab('reports')}>Reports</button>
          {user && user.roles && (user.roles.includes('ROLE_ADMIN') || user.roles.includes('ROLE_OPERATOR') || user.roles.includes('ROLE_SUPERVISOR')) && (
            <button className={tab==='mapping' ? 'btn primary' : 'btn secondary'} onClick={()=>setTab('mapping')}>Mapping</button>
          )}
          <button className="btn secondary" style={{marginTop:32}} onClick={()=>nav('/dashboard')}>Back to Home</button>
        </div>
      </div>
      <div style={{flex:1}}>
        {tab==='reports' && (
          <ReportsPage company={company} canApprove={!!(user && user.roles && user.roles.includes('ROLE_ADMIN'))} isSupervisor={!!isSupervisor} />
        )}
        {tab==='mapping' && user && user.roles && (user.roles.includes('ROLE_ADMIN') || user.roles.includes('ROLE_OPERATOR') || user.roles.includes('ROLE_SUPERVISOR')) && (
          <>
            <div style={{display:'flex',gap:24,alignItems:'flex-start'}}>
              {/* Supervisor Panel (only for admin) */}
              {user && user.roles && user.roles.includes('ROLE_ADMIN') && (
                <div style={{background:'#fff',padding:18,borderRadius:10,boxShadow:'0 4px 16px rgba(34,50,80,0.06)',width:400,height:420,overflowY:'auto',flexShrink:0}}>
                  <h3>Supervisor Mapping</h3>
                  <form onSubmit={editId ? handleEdit : handleAdd} style={{display:'flex',gap:8,marginBottom:16}}>
                    <input
                      placeholder="Supervisor name"
                      value={editId ? editName : newName}
                      onChange={e => editId ? setEditName(e.target.value) : setNewName(e.target.value)}
                      style={{flex:1,padding:8,borderRadius:6,border:'1px solid #e6eaf0'}}
                      required
                      disabled={loading}
                    />
                    <button className="btn primary" type="submit" disabled={loading}>{editId ? 'Save' : 'Add'}</button>
                    {editId && <button className="btn secondary" type="button" onClick={()=>{setEditId(null);setEditName('')}} disabled={loading}>Cancel</button>}
                  </form>
                  <ul style={{listStyle:'none',padding:0}}>
                    {supervisors.map(sup => (
                      <li key={sup.id} style={{display:'flex',alignItems:'center',gap:8,marginBottom:8,borderBottom:'1px solid #eef2f6',padding:'6px 0'}}>
                        <span style={{flex:1}}>{sup.name}</span>
                        <button className="btn secondary" style={{fontSize:13}} onClick={()=>startEdit(sup)} disabled={loading}>Edit</button>
                        <button className="btn secondary" style={{fontSize:13}} onClick={()=>handleDelete(sup.id)} disabled={loading}>Delete</button>
                      </li>
                    ))}
                    {supervisors.length === 0 && <li style={{color:'#888'}}>No supervisors yet.</li>}
                  </ul>
                </div>
              )}
              {/* Route Panel (for admin, operator, supervisor) */}
              <div style={{background:'#fff',padding:18,borderRadius:10,boxShadow:'0 4px 16px rgba(34,50,80,0.06)',width:520,height:420,overflowY:'auto',flexShrink:0}}>
                <RouteMapping
                  company={company}
                  canEdit={user && (user.roles.includes('ROLE_ADMIN') || user.roles.includes('ROLE_OPERATOR') || user.roles.includes('ROLE_SUPERVISOR'))}
                  canEditSupervisors={user && user.roles.includes('ROLE_ADMIN')}
                  supervisorId={user && user.roles.includes('ROLE_SUPERVISOR') ? user.id : undefined}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
